import CreditCapabilities from '../../../views/credit/CreditCapabilities';

export const requirements = {
  flipFlopRequirements: [],
};

export const verifier = () => {
  return CreditCapabilities.canViewUsers();
};
